// Meta Pixel event helpers.
//
// The pixel snippet in public/index.html fires PageView on load. These two
// events are what the ad campaigns optimize against, so they must fire once
// per real conversion — not on re-render, and not while the user is only
// looking at a form.
//
// Safe to call when the pixel is blocked (ad blockers) or not yet loaded:
// fbq is simply absent and these become no-ops.

/** A new account was created. Meta's standard event for signups. */
export function trackSignup() {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'CompleteRegistration');
}

/** A season membership was paid for. Value lets Meta optimize on revenue. */
export function trackPurchase(amountUsd = 10) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'Purchase', { value: amountUsd, currency: 'USD' });
}
